import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project imports
import CronDashboard from "Adminviews/dashboard/crondashboard";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import { moduleHref } from "menu-items/sectionTabs";
import PdfViewerPage from '../Collab-community-views/dashboard/wellness-program/PdfViewerPage';

// const CharityReport = Loadable(lazy(() => import('Collab-community-views/dashboard/CharityReport')));
const PersonalDashboard = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Personal-Dashboard"))
);
const Profile = Loadable(lazy(() => import("Collab-community-views/profile")));
const Follower = Loadable(
  lazy(() => import("Collab-community-views/FollowersPage"))
);
const CollabProfile = Loadable(
  lazy(() => import("Collab-community-views/profile"))
);
const CommunityDashboard = Loadable(
  lazy(() => import("Collab-community-views/CommunityDashboard"))
);
// One route for the Dashboard module's three views. /Hall_Of_Fame and /TFMasters
// are redirects into it below, so this is the only page that renders them.
const DashboardModulePage = Loadable(
  lazy(() => import("Collab-community-views/CommunityDashboard/ModulePage"))
);
const EarningsUploadForm = Loadable(
  lazy(() => import("../Adminviews/dashboard/FAAdmin/EarningsUploadForm"))
);

const Learning = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Learning"))
);
const PersonalDashboardNew = Loadable(
  lazy(() =>
    import(
      "Collab-community-views/dashboard/Personal-Dashboard/PersonalDashboardNew"
    )
  )
);
const StockAlert = Loadable(
  lazy(() => import("Collab-community-views/dashboard/StockAlert_new"))
);
const AllWatchlist = Loadable(
  lazy(() =>
    import("Collab-community-views/dashboard/Personal-Dashboard/AllWatchlist")
  )
);
const AllCore = Loadable(
  lazy(() =>
    import("Collab-community-views/dashboard/Personal-Dashboard/AllCore")
  )
);
const Register1 = Loadable(
  lazy(() => import("views/pages/authentication/authentication/Register"))
);
const Login1 = Loadable(
  lazy(() => import("views/pages/authentication/authentication/Login"))
);
const Forgotpassword1 = Loadable(
  lazy(() => import("views/pages/authentication/authentication/ForgotPassword"))
);
const Help = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Help"))
);
const Resources = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Resources"))
);
// The Events module's own page. Events traded places with Hall of Fame: it left
// the Dashboard's switcher for Community's row, so it renders directly here
// instead of through ModulePage, the way Hall of Fame used to. Hall of Fame needs
// no entry of its own — ModulePage lazy-loads it as one of the module's views.
const EventsPage = Loadable(
  lazy(() => import("Collab-community-views/dashboard/NewEvent"))
);
// Placeholder until the Global Investing module is built.
const GlobalInvesting = Loadable(
  lazy(() => import("Collab-community-views/dashboard/GlobalInvesting"))
);
const CoreAudit = Loadable(
  lazy(() => import("Collab-community-views/dashboard/CoreAudit"))
);
const RecommendedWatchlist = Loadable(
  lazy(() => import("Collab-community-views/dashboard/RecommendedWatchlist"))
);
const SWatchlist = Loadable(
  lazy(() =>
    import("Collab-community-views/dashboard/Personal-Dashboard/SWatchlist")
  )
);
const Users = Loadable(lazy(() => import("Adminviews/dashboard/Users")));
const Utilization = Loadable(
  lazy(() => import("Adminviews/dashboard/Utilization"))
);
const QuantumGroup = Loadable(
  lazy(() => import("Adminviews/dashboard/QuantumGroup"))
);
const WatchList = Loadable(
  lazy(() => import("Adminviews/dashboard/WatchList"))
);
const CharityReport = Loadable(
  lazy(() => import("Adminviews/dashboard/CharityReport"))
);
const SateliteWatchlist = Loadable(
  lazy(() => import("Collab-community-views/dashboard/SatelliteWatchlist"))
);
const ComingSoon = Loadable(
  lazy(() => import("Collab-community-views/ComingSoon"))
);
// /contact-us and /HelpResponse are the same merged page, so they must share one
// Loadable. Loadable() returns a fresh function on every call, and two of them
// over the same import would be two distinct component types — React would
// unmount/remount on every sidebar switch instead of just changing tabs.
const DhurvaHelp = Loadable(
  lazy(() => import("Collab-community-views/contact-us"))
);
const CoreWatchlist = Loadable(
  lazy(() => import("Collab-community-views/dashboard/CoreWatchlist"))
);
const User_Management = Loadable(
  lazy(() => import("Collab-community-views/dashboard/User_management"))
);
const Report = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Trace"))
);
const Event_Management = Loadable(
  lazy(() => import("Adminviews/dashboard/Event_management"))
);
const Help_Management = Loadable(
  lazy(() => import("Adminviews/dashboard/Help_management"))
);
// Admin CRUD for the onboarding checklist the user sees at /Onboarding. Kept a
// separate route from the user-facing page.
const Onboarding_Management = Loadable(
  lazy(() => import("Adminviews/dashboard/OnboardingManagement"))
);
const Satelite = "satelite";
const Core = "core";
const Core_Watchlist = Loadable(
  lazy(() => import("Adminviews/dashboard/CoreWatchlist"))
);
const FundamentalAnalysisAdmin = Loadable(
  lazy(() => import("Adminviews/dashboard/FundamentalAnalysis"))
);
const TFMastersAdmin = Loadable(
  lazy(() => import("Adminviews/dashboard/TFMastersAdmin"))
);
const TFPulseAdmin = Loadable(
  lazy(() => import("Adminviews/dashboard/TFPulseAdmin"))
);
const CactusWatchlist_Admin = Loadable(
  lazy(() => import("Adminviews/dashboard/CatcusWatchlist"))
);
const CactusWatchlist = Loadable(
  lazy(() =>
    import("Collab-community-views/dashboard/CatcusWatchlist/Index.js")
  )
);

const Excel_Export = Loadable(
  lazy(() =>
    import("Collab-community-views/dashboard/ExcelExport/Excel_Export.js")
  )
);
const EodDownload = Loadable(lazy(() => import("Adminviews/dashboard/EOD")));

const Onboarding = Loadable(
  lazy(() => import("Collab-community-views/dashboard/OnBoarding"))
);
const Calculator = Loadable(
  lazy(() => import("Collab-community-views/dashboard/Calculator"))
);
const QicAdmin = Loadable(lazy(() => import("Adminviews/dashboard/QIC")));
const AdminQicUser = Loadable(
  lazy(() => import("Adminviews/dashboard/QIC/Table/User"))
);
const AdminQicTeam = Loadable(
  lazy(() => import("Adminviews/dashboard/QIC/Table/Team"))
);
const ShortlistTable = Loadable(
  lazy(() => import("Collab-community-views/QIC/Team/ShortListTable"))
);
const QuantumInvestingChampion = Loadable(
  lazy(() => import("Collab-community-views/QIC"))
);
const EventQicDashboard = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event"))
);
const Stage1 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage1"))
);
const Stage2 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage2"))
);
const Stage3 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage3"))
);
const Stage4 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage4"))
);
const Stage5 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage5"))
);
const Stage6 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage6"))
);
const Stage7 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage7"))
);
const Stage8 = Loadable(
  lazy(() => import("Collab-community-views/QIC/Event/Stages/Stage8"))
);
const Semi_Finalists = Loadable(
  lazy(() => import("Collab-community-views/QIC/Winners/index.js"))
);
const QicAdminCreateTeam = Loadable(
  lazy(() => import("Adminviews/dashboard/QIC/CreateTeam"))
);
const StageTable = Loadable(
  lazy(() => import("Adminviews/dashboard/QICEvent/StageTable"))
);
const QicEvent = Loadable(lazy(() => import("Adminviews/dashboard/QICEvent")));
const Quiz = Loadable(
  lazy(() =>
    import("Collab-community-views/QIC/Business_Ranking_Calculator/Quiz")
  )
);
const VotingAdmin = Loadable(
  lazy(() => import("Adminviews/dashboard/QICEvent/Voting/Index"))
);
const QicWinnerShortlistTable = Loadable(
  lazy(() => import("Adminviews/dashboard/QIC/WinnerShortlistTable"))
);
const Demo_video_link = Loadable(
  lazy(() => import("Adminviews/dashboard/upload_demo_video_link/index"))
);
const CoreIdeas = Loadable(
  lazy(() => import("Collab-community-views/dashboard/SectorDashboard/index"))
);
const MyBooks = Loadable(
  lazy(() => import("Collab-community-views/dashboard/MyBooksHtml"))
);


const CommunityNotes = Loadable(
  lazy(() => import("Collab-community-views/dashboard/StockoPediaNew/index.js"))
);
const PortfolioSizing = Loadable(
  lazy(() => import("Collab-community-views/dashboard/PortfolioSizingCal/index.js"))
);
const PyramidCalculator = Loadable(
  lazy(() => import("Collab-community-views/dashboard/PyramidCalculator/index.js"))
);
const PortfolioAccelerator = Loadable(
  lazy(() => import("Collab-community-views/dashboard/PortfolioAccelerator/index.js"))
);

// Book Hive
const BookHive = Loadable(lazy(()=>import('Collab-community-views/dashboard/BookHive/index.js')));
const AddBookHive =Loadable(lazy(()=>import('Collab-community-views/dashboard/BookHive_Management/ADD/AddBookHive.js')));
const EditBookHive =Loadable(lazy(()=>import('Collab-community-views/dashboard/BookHive_Management/EDIT/EditBookHive.js')));
const Sector = "SectorWatchList";

const SectorDashboardWatchlist=Loadable(lazy(()=>import('Collab-community-views/dashboard/SectorDashboardWatchList/component/AllWatchlist.js')));
const SectorDashboard = Loadable(
  lazy(() => import("Collab-community-views/dashboard/SectorDashboard/index"))
);

// Sector WatchList
const SectorWatchList = Loadable(
  lazy(() => import("Collab-community-views/dashboard/SectorWatchList/index.js"))
);

// OmniWealth — the product shelf. Its own top-level page and sidebar entry,
// shaped like Sector's: no section tab strip, and no props.
const OmniWealth = Loadable(
  lazy(() => import("Collab-community-views/dashboard/OmniWealth/index.js"))
);

// Community Notes
const CommunityNotesAdmin = Loadable(
  lazy(() => import("Adminviews/dashboard/CommunityNotesAdmin"))
);

// const CommunityNotesCompanyManagement = Loadable(
//   lazy(() => import("Adminviews/dashboard/CMCompanyManagement"))
// );

const CommunityNotesManagement = Loadable(
  lazy(() => import("Adminviews/dashboard/CMCompanyManagement"))
);


const CommunityNotesContributors = Loadable(
  lazy(() => import("Collab-community-views/dashboard/CommunityNotesContributors"))
);

// Research Report
const ResearchReport = Loadable(
  lazy(() => import("Collab-community-views/dashboard/ResearchReport/index.js"))
);

const IdeaSatellite=Loadable(lazy(()=>import('Collab-community-views/dashboard/IdeaSatellite/index.js')));
const ValuationCalculator = Loadable(
  lazy(() => import("Collab-community-views/dashboard/ValuationCalculator/index.js"))
);

const Quiz2 = Loadable(
  lazy(() =>
    import("Collab-community-views/QIC/Strong_Calculator/Quiz")
  )
);
const IdeaSatelliteOne=Loadable(lazy(()=>import('Collab-community-views/dashboard/IdeaSatelliteOne/index.js')));
const IdeaSector=Loadable(lazy(()=>import('Collab-community-views/dashboard/IdeaSector/index.js')));

const WellnessProgram=Loadable(
  lazy(()=>import('Collab-community-views/dashboard/wellness-program/WellnessProgram.js'))
);

const Admin_WellnessEvent = Loadable(lazy(()=>import('../Adminviews/dashboard/WellnessEvent/index.js')))
const QICComingSoon = Loadable(lazy(() => import("Collab-community-views/dashboard/qic_CommingSoon")));


const DhruvaQuickGuide = Loadable(lazy(() => import("Collab-community-views/dashboard/QuickGuide/index.js")));

const QuantumInvestingChampion2025 = Loadable(lazy(() => import("Collab-community-views/QIC")));
const QICLIVE = Loadable(lazy(() => import("Collab-community-views/QIC/QIC_LIVE_message/index.js")));
const BooKClub=Loadable(lazy(()=>import('Collab-community-views/dashboard/Book Club/AllBooks.js')));

const AddBooK=Loadable(
  lazy(()=>import('Collab-community-views/dashboard/Book Club/Book Club Management/index'))
);


const CoachListing =Loadable(
  lazy(()=>import('Collab-community-views/dashboard/Universe_Coach/index'))
);

const UniversityAdmin = Loadable(
  lazy(() => import("../Adminviews/dashboard/University"))
);

// Ask Chanakya (the Zapier chat embed) is not part of the RAG ticket resolver
// and stays routed exactly as before.
const CoachListingZapierChatboth =Loadable(
  lazy(()=>import('Collab-community-views/dashboard/ChatbotZapier/index.js'))
);

const GoogleSuccess = Loadable(
  lazy(() =>
    import("../views/pages/authentication/auth-forms/google_success.js"),
  ),
);

const AdminMenuPage = Loadable(
  lazy(() => import("../Adminviews/menu/AdminMenu.jsx"))
);
const FeatureToggle = Loadable(
  lazy(() => import("../Adminviews/dashboard/FeatureToggle"))
);

const Help_Status = Loadable(
  lazy(() => import("Adminviews/dashboard/Help_management/HelpStatus"))
);
const Help_Feature_Requests = Loadable(
  lazy(() => import("Adminviews/dashboard/HelpFeatureRequests"))
);
const ReferenceAdmin = Loadable(
  lazy(() => import("../Adminviews/dashboard/ReferenceAdmin"))
);

const Pratiksha = Loadable(lazy(()=>import('Collab-community-views/dashboard/MyWatchlist/MyWatchlist')));
// AI TICKET RESOLUTION DISABLED — the admin AI Help Desk screen is not routed.
// const AIHelpDeck = Loadable(lazy(()=>import('../Adminviews/dashboard/AIHelpDeck/index.js')));

const MeetupAdmin = Loadable(lazy(()=>import('../Adminviews/dashboard/MeetupEvent/index.js')));
const ResearchReportAdmin = Loadable(lazy(()=>import('../Adminviews/dashboard/ResearchReportAdmin/index.js')));
const Nakshatra = Loadable(lazy(()=>import('../Collab-community-views/dashboard/StageAnalysisDashboard/index.js')));

const InvoiceManagementDashboard = Loadable(lazy(() => import('../Adminviews/dashboard/InvoiceManagent/index.js')));

const MyList = Loadable(lazy(() => import('../Collab-community-views/dashboard/MyList/index.js')));
// The member page and its admin sit together here because they read one list:
// the companies the admin makes available are the ones the member's picker
// offers. The route for it is /Admin/MyList, beside the other admin pages.
const MyListAdmin = Loadable(lazy(() => import('../Adminviews/dashboard/MyListAdmin/index.js')));
const UserReportDashboard = Loadable(lazy(() => import('../Adminviews/dashboard/UserReport/index.js')));

const MainRoutes = {
  path: "/",
  children: [
    // ✅ PUBLIC ROUTE (NO AUTHGUARD)
    {
      path: "/google_success",
      element: <GoogleSuccess />,
    },

    // ✅ PUBLIC ROUTE (NO AUTHGUARD / NO MAIN LAYOUT)
    // Same Wellness page component as the in-app "/WellnessProgram", rendered
    // in public mode so it can be shared with logged-out visitors.
    {
      path: "/WellnessProgramPublic",
      element: <WellnessProgram isPublic />,
    },

    // 🔐 PROTECTED ROUTES
    {
      path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
        {
      path: "/AdminDashboard",
      element: <AdminMenuPage />,
    },
      {
      path: "/invoicemanagementdashboard",
      element: <InvoiceManagementDashboard />,
    },
    {
      path: "/userreportdashboard",
      element: <UserReportDashboard />,
    },
     {
            path:"/ChatbotZapier",
            element : <CoachListingZapierChatboth/>
        },
    {
      path: "/Profile",
      element: <Profile />,
    },
       {
      path: "/meetupadmin",
      element: <MeetupAdmin />,
    },
   {
      path: "/nakshatra",
      element: <Nakshatra/>,
    },
    // AI TICKET RESOLUTION DISABLED — the admin AI Help Desk screen is not
    // routed. Its files under Adminviews/dashboard/AIHelpDeck are preserved.
    // {
    //   path: "/AIHelpDeck",
    //   element: <AIHelpDeck />,
    // },
    {
      path: "/Personal-Dashboard",
      element: <PersonalDashboard />,
    },
    {
      path: "/profile/:tab",
      element: <CollabProfile />,
    },
    {
      path: "/CommunityDashboard",
      element: <DashboardModulePage />,
    },
    {
      path: "/Learning",
      element: <Learning />,
    },
    {
      path: "/PersonalDashboardNew",
      element: <PersonalDashboardNew />,
    },
    {
      path: "/Watchlist",
      element: <SWatchlist />,
    },
    {
      path: "/CoreWatchlist",
      element: <CoreWatchlist WatchlistType={Satelite} />,
    },
    {
      path: "/CactusWatchlist",
      element: <CactusWatchlist WatchlistType={Satelite} />,
    },
    {
      path: "/recommended_watchlist",
      element: <RecommendedWatchlist WatchlistType={Satelite} />,
    },
     {
      path: "/mylist",
      element: <MyList />,
    },
    {
      path: "/followerspage/:tab/:Friendid",
      element: <Follower />,
    },
    {
      path: "/AllWatchlist",
      element: <AllWatchlist />,
    },
    {
      path: "/AllCore",
      element: <CoreAudit />,
    },
   
    {
      path: "/contact-us",
      element: <DhurvaHelp />,
    },
    {
      path: "/Resources",
      element: <Resources />,
    },
    {
      path: "/GlobalInvesting",
      element: <GlobalInvesting />,
    },
    {
      path: "/Hall_Of_Fame",
      // A view of the Dashboard module now, not a page of its own — it took the
      // switcher slot Events gave up. The inbound links from the profile menu and
      // anywhere else still land on the right view.
      element: <Navigate to={moduleHref("hall-of-fame")} replace />,
    },
    {
      path: "/Reports",
      element: <Users />,
    },
    {
      path: "/fa_upload",
      element: <EarningsUploadForm />,
    },
    {
      path: "/UtilityReport",
      element: <Report />,
    },
    {
      path: "/Utilization",
      element: <Utilization />,
    },
    {
      path: "/QuantumGroup",
      element: <QuantumGroup />,
    },
    {
      path: "/WatchListReport",
      element: <WatchList />,
    },
    {
      path: "/CharityReport",
      element: <CharityReport />,
    },
    {
      path: "/TrendingWatchList",
      element: <CommunityDashboard />,
    },
    {
      path: "/SateliteWatchlist",
      element: <SateliteWatchlist WatchlistType={Satelite} />,
    },
    {
      path: "/CoreWatchlist",
      element: <SateliteWatchlist WatchlistType={Core} />,
    },
    {
      path: "/User_Management",
      element: <User_Management />,
    },
    {
      path: "/Event_Management",
      element: <Event_Management />,
    },
    {
      path: "/HelpResponse",
      element: <DhurvaHelp />,
    },
    {
      path: "/Help_Management",
      element: <Help_Management />,
    },
     {
      path: "/Help_Status",
      element: <Help_Status />,
    },
     {
      path: "/Help_Feature_Requests",
      element: <Help_Feature_Requests />,
    },
     {
      path: "/ec2_type_change",
      element: <FeatureToggle />,
    },
    {
      path: "/cron_dashboard",
      element: <CronDashboard />,
    },
    {
      path: "/Core_Watchlist",
      element: <Core_Watchlist />,
    },
    {
      path: "/CactusWatchlist_Admin",
      element: <CactusWatchlist_Admin />,
    },
    {
      path: "/Excel_Export",
      element: <Excel_Export />,
    },
    {
      path: "/eod_download",
      element: <EodDownload />,
    },
    {
      path: "/Onboarding",
      element: <Onboarding />,
    },
    {
      path: "/Onboarding_Management",
      element: <Onboarding_Management />,
    },
    {
      path: "/calculator",
      element: <Calculator />,
    },
    {
      path: "/qic_admin",
      element: <QicAdmin />,
    },
    {
      path: "/Admin/Qic/User",
      element: <AdminQicUser />,
    },
    {
      path: "/Admin/Qic/Team",
      element: <AdminQicTeam />,
    },
    {
      path: "/User/Qic/Team",
      element: <ShortlistTable />,
    },
    {
      path: "/qic/dashboard",
      element: <QuantumInvestingChampion />,
    },
    {
      path: "/qic/dashboard/event",
      element: <EventQicDashboard />,
    },
    {
      path: "/qic/dashboard/event/stage1",
      element: <Stage1 />,
    },
    {
      path: "/qic/dashboard/event/stage2",
      element: <Stage2 />,
    },
    {
      path: "/qic/dashboard/event/stage3",
      element: <Stage3 />,
    },
    {
      path: "/qic/dashboard/event/stage4",
      element: <Stage4 />,
    },
    {
      path: "/qic/dashboard/event/stage5",
      element: <Stage5 />,
    },
    {
      path: "/qic/dashboard/event/stage6",
      element: <Stage6 />,
    },
    {
      path: "/qic/dashboard/event/stage7",
      element: <Stage7 />,
    },
    {
      path: "/qic/dashboard/event/stage8",
      element: <Stage8 />,
    },
    {
      path: "/qic/dashboard/winners",
      element: <Semi_Finalists />,
    },
    {
      path: "/qic_event",
      element: <QicEvent />,
    },
    {
      path: "/qic_admin/createteam",
      element: <QicAdminCreateTeam />,
    },
    {
      path: "/qic_event/stages",
      element: <StageTable />,
    },
    {
      path: "/qic/businessranking_calculator",
      element: <Quiz />,
    },
    {
      path: "/qic/Strong_Calculator",
      element: <Quiz2 />,
    },
    {
      path: "/qic/setting_qicvotes",
      element: <VotingAdmin />,
    },
    {
      path: "/Admin/Qic/WinnerShortlist",
      element: <QicWinnerShortlistTable />,
    },
    {
      path: "/demo_video_link",
      element: <Demo_video_link />,
    },
    {
      path: "/CoreIdeas",
      element: <CoreIdeas />,
    },
    {
      path:"mybooks",
      element:<MyBooks/>
    },
    // {
    //   path: "/CommunityNotes",
    //   element: <CommunityNotes/>,
    // },
    {
      path: "/TFMasters",
      // A view of the Dashboard module now, not a page. `replace` keeps Back
      // going where the user came from rather than into this redirect again.
      element: <Navigate to={moduleHref("tf-masters")} replace />,
    },
    {
      path: "/ResearchReport",
      element: <ResearchReport />,
    },
    {
      path: "/Admin/ResearchReport",
      element: <ResearchReportAdmin />,
    },
    {
      path: "/Calculator/PortfolioSizing",
      element: <PortfolioSizing />,
    },
    {
      path: "/Calculator/Pyramid",
      element: <PyramidCalculator />,
    },
    {
      path: "/Calculator/Portfolio_Accelerator",
      element: <PortfolioAccelerator />,
    },
    {
      path: '/BookHive',
      element: <BookHive/>
  },
  {
    path:'/AddBookHive',
    element:<AddBookHive/>
},
{
    path:'/EditBookHive',
    element:<EditBookHive/>
},
{
  path: "/SectorWatchList",
  element: <SectorWatchList WatchlistType={Sector} />,
},
{
  path: "/OmniWealth",
  element: <OmniWealth />,
},
{
  path:'/SectorDashboardWatchlist',
  element:<SectorDashboardWatchlist/>
},
{
  path: "/SectorDashboard",
  element: <SectorDashboard />,
},
	// {
  //     path:'/CommunityNotesManagement',
  //     element:<CommunityNotesManagement/>
  //   },
    // {
    //   path:'/CommunityNotesContributors',
    //   element:<CommunityNotesContributors/>
    // },
// {
//   path:'/CommunityNotesCompanyManagement',
//   element:<CommunityNotesCompanyManagement/>
// },
{
  path:'/CommunityNotesContributors',
  element:<CommunityNotesContributors/>
},
{
  path:'/IdeaSatellite',
  element:<IdeaSatellite/>
},
{
  path: "/Calculator/Valuation_Calculator",
  element: <ValuationCalculator />,
},
  {
      path: "/IdeaSatelliteOne",
      element: <IdeaSatelliteOne />,
    },
    {
      path: "/Admin/FA",
      element: <FundamentalAnalysisAdmin />,
    },
    {
      path: "/Admin/TFMasters",
      element: <TFMastersAdmin />,
    },
    {
      path: "/Admin/TFPulse",
      element: <TFPulseAdmin />,
    },
    {
      path: "/Admin/MyList",
      element: <MyListAdmin />,
    },
    {
      path: "/IdeaSector",
      element: <IdeaSector />,
    },
    {
      path:'/WellnessProgram',
      element:<WellnessProgram/>
    },
    {
      path:"/pdf-viewer",
      element:<PdfViewerPage />
    },
    {
      path:"/WellnessEvent",
      element:<Admin_WellnessEvent />
    },
	  {
      path:"/QICComingSoon",
      element:<QICComingSoon />
    },
    {
      path:"/quickguide",
      element:<DhruvaQuickGuide />
    },
    {
      path: "/qic/dashboard2025",
      element: <QuantumInvestingChampion2025 />,
    },
    {
      path: "/qic/live",
      element: <QICLIVE />,
    },
    {
      path: "/bookClub",
      element: <BooKClub />,
    },
    {
      path: "/BookClubAdmin",
      element: <AddBooK />,
    },
    {
      path: "/UniverseCoach",
      element: <CoachListing />,
    },
    {
      path: "/University",
      element: <UniversityAdmin/>,
        },
        {
      path: "/ReferenceAdmin",
      element: <ReferenceAdmin />,
    },
    {
      path: "/Events",
      // A page of its own now, not a view of the Dashboard module — it traded
      // places with Hall of Fame. The inbound links from the Dashboard's Events
      // tile, Personal-Dashboard and Resources/Techno land here unchanged.
      element: <EventsPage />,
    },
      {
      path: "/pratiksha",
      element: <Pratiksha />,
     },
      ],
    },
  ],
};
export default MainRoutes;
